<script setup lang="ts">
import type { AccordionProps } from '@/shared/ui/Accordion/model/types/accordion';
import AccordionPanel from '@/shared/ui/Accordion/ui/AccordionPanel.vue';

withDefaults(defineProps<AccordionProps>(), {
  isCollapsed: false,
  isClosable: false,
  isVisiblePanel: true,
});

const isLocalCollapsed = defineModel<boolean>({ default: true });
const isMobile: boolean = useIsMobile();
</script>

<template>
  <div
    data-testid="accordion"
    :class="[
      'app-collapse-accordion',
      { _active: !isLocalCollapsed },
      { _mobile: isMobile },
    ]"
  >
    <AccordionPanel
      v-if="isVisiblePanel"
      v-model="isLocalCollapsed"
      :icon-width="iconWidth"
      :icon-height="iconHeight"
    >
      <slot name="accordion"></slot>
      <template #right>
        <slot name="accordion-right"></slot>
      </template>
    </AccordionPanel>
    <slot v-else name="accordion"></slot>
    <div data-testid="accordion-content" class="app-collapse-accordion__wrapper">
      <div class="app-collapse-accordion__inner">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="less">
.app-collapse-accordion {
  .flex-column(0);

  width: 100%;

  &__wrapper {
    width: 100%;
    display: grid;
    grid-template-rows: 0fr;
    background-color: #fff;
    transition: grid-template-rows @A ease-in-out;
  }

  &__inner {
    overflow: hidden;
    min-width: 0;
    min-height: 0;
  }

  &._active > &__wrapper {
    grid-template-rows: 1fr;
  }

  &._active > &__wrapper > &__inner {
    overflow: visible;
    transition: overflow 0s linear @A allow-discrete;
  }

  &._mobile &__wrapper {
    margin-top: 2px;
    border-radius: @main-size;
  }
}
</style>
